import {interval, Observable, Scheduler} from 'rxjs';
import {filter, map, withLatestFrom}     from 'rxjs/operators';

import getUserDevice           from '../../../Shared/Util/getUserDevice';
import Playback                from '../../../State/Stores/Playback/Playback';
import SyntheticMediaEventType from '../Constants/SyntheticMediaEventType';

const INTERVAL_DURATION = 300;
const INTERVAL_DURATION_IE = 800;

const createTimeUpdateStream = (
    playbackStoreUpdate$: Observable<Playback>,
    scheduler?: Scheduler
): Observable<SyntheticMediaEventType> => {
    const userDevice = getUserDevice(navigator.userAgent);
    const intervalDuration = userDevice.isInternetExplorer ? INTERVAL_DURATION_IE : INTERVAL_DURATION;

    return interval(intervalDuration, scheduler)
        .pipe(
            withLatestFrom(playbackStoreUpdate$),
            filter(([, {hasEnded}]) => !hasEnded),
            map(() => SyntheticMediaEventType.TIME_UPDATE)
        );
};

export default createTimeUpdateStream;